import { getDataPrivacySettings } from 'forms-utils-lib/dataPrivacySettings/client/DataPrivacySettings';
const createAction = name => `@@dataPrivacySettings/${name}`;
export const REQUEST_DATA_PRIVACY_SETTINGS = createAction('REQUEST_DATA_PRIVACY_SETTINGS');
export const RECEIVE_DATA_PRIVACY_SETTINGS = createAction('RECEIVE_DATA_PRIVACY_SETTINGS');
export const FAIL_DATA_PRIVACY_SETTINGS = createAction('FAIL_DATA_PRIVACY_SETTINGS');
export const requestDataPrivacySettings = () => ({
  type: REQUEST_DATA_PRIVACY_SETTINGS
});
export const receiveDataPrivacySettings = payload => ({
  type: RECEIVE_DATA_PRIVACY_SETTINGS,
  payload
});
export const failDataPrivacySettings = () => ({
  type: FAIL_DATA_PRIVACY_SETTINGS
});
export const fetchDataPrivacySettings = ({
  earlyRequestKey
} = {}) => dispatch => {
  dispatch(requestDataPrivacySettings());
  return getDataPrivacySettings({
    earlyRequestKey
  }).then(dataPrivacySettings => {
    dispatch(receiveDataPrivacySettings(dataPrivacySettings));
  }).catch(() => {
    dispatch(failDataPrivacySettings());
  });
};